import { createI18n } from "vue-i18n";
import dateFormat from "./configs/dateFormat.json";

// Import des fichiers de langues
const importsJsonLang = {
  fr: import.meta.glob(`./locales/fr/*.json`, {eager: true}),
  en: import.meta.glob(`./locales/en/*.json`, {eager: true}),
  es: import.meta.glob(`./locales/es/*.json`, {eager: true}),
  de: import.meta.glob(`./locales/de/*.json`, {eager: true}),
  it: import.meta.glob(`./locales/it/*.json`, {eager: true}),
};

// Liste des langues importés
const localesI18n = Object.keys(importsJsonLang);

// Function to retrieve all messages
const getLocaleMessages = () => {
  const messages: Record<string, any> = {};
  localesI18n.forEach(locale => {
    messages[locale] = {};
    Object.values(importsJsonLang[locale]).forEach(module => {
      Object.assign(messages[locale], module.default);
    });
  });
  return messages;
};



const i18n = createI18n({
  // Mode Composition. Le mode Legacy est l'implicite historique de vue-i18n, mais il est
  // déprécié en v11 et supprimé en v12 : rester dessus aurait bloqué la montée de version.
  //
  // Conséquence sur le code appelant : `i18n.global.locale` n'est plus une chaîne mais une
  // référence, il faut lire et écrire `.value`. Le reste de l'API utilisée ici — `t`, `d`,
  // `te` — est identique, et `useI18n()` devient le chemin natif pour les composants qui
  // l'emploient déjà.
  legacy: false,
  locale: "fr",
  // Explicite plutôt qu'implicite : vue-i18n retombe de toute façon sur `locale`, mais le
  // repli français est une décision assumée (voir Documents/Audit_i18n/AUDIT_i18n.md §11)
  // et non un effet de bord de la configuration.
  fallbackLocale: "fr",
  globalInjection: true,
  messages: getLocaleMessages(),
  datetimeFormats: {
    fr: {
      short: {
        year: "numeric",
        month: "numeric",
        day: "numeric",
      },
      long: {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      },
      longString: {
        year: "numeric",
        month: "long",
        day: "2-digit",
        weekday: "long",
      },
      time : {
        hour : "2-digit",
        minute : "2-digit"
      },
      fulltime : {
        hour : "2-digit",
        minute : "2-digit",
        second : "2-digit"
      }
    },
    en: {
      short: {
        year: "numeric",
        month: "numeric",
        day: "numeric",
      },
      long: {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      },
      longString: {
        year: "numeric",
        month: "long",
        day: "2-digit",
        weekday: "long",
      },
    },
  },
});

export default i18n;
